<template>
  <div style="flex:1;height: 1px;display: flex;flex-direction:column;margin: 0px 0 10px 0;">
    <div style="width: 100%;height: 100%; border: 1px solid rgba(43, 143, 222, 1);
            position: relative;
            box-sizing: border-box;display: flex;">

      <template v-if="hasSim">
        <div style="
                  width: 150px;
                  background-color: #d6deee;
                  padding: 10px;
                  display: flex;
                  flex-direction: column;
                  box-sizing: border-box;
                  border-right: 1px solid rgba(163, 188, 208, 1);
                ">
          <div
              style="
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #333333;
                    height: 33px;
                    line-height: 33px;
                    text-align: center;
                  "
          >
            目录
          </div>
          <div style="flex: 1; background: #fff; overflow: auto">
            <template v-for="(item,idx) in showGroupSims">
              <p v-if="item.category === 0" class="catalogue_item" :key="idx" :class="{
                               active_catalogue_item: item.groupId == currentGroupId
                             }" @click="changeCatalog(item)">{{ `投标异常组${idx + 1}` }}</p>
              <p v-else class="catalogue_item" :key="idx" :class="{
                               active_catalogue_item: item.groupId == currentGroupId
                             }" @click="changeCatalog(item)">{{ `招标相似组${idx + 1}` }}</p>
            </template>
          </div>
        </div>
        <div style="flex: 1;width: 1px;height: 100%;">
          <el-table :data="currentSimList" :header-cell-style="{
                    color: '#000',
                    height: '48px',
                  }"
                    height="250"
                    style="border: 1px solid #eee">

            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="序号"
                type="index">

            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="错别字"
                prop="ori">

            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="正确应为"
                prop="correct">

            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="基准文件"
              >
              <template slot-scope="scope">
                {{ scope.row.name + "—" + scope.row.mulu }}
              </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="错误数量"
                prop="mulu_count"
                >

            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="错误所在页码"
                prop="mulu_page_number"
            >
              <template slot-scope="scope">
                {{ scope.row.mulu_page_number.join(",") }}
              </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="对比文件"
            >
              <template slot-scope="scope">
                {{ scope.row.cont_name + "—" + scope.row.cont_mulu }}
              </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="错误数量"
                prop="cont_mulu_count"
            >

            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                align="left"
                header-align="left"
                label="错误所在页码"
                prop="cont_mulu_page_number"
            >
              <template slot-scope="scope">
                {{ scope.row.cont_mulu_page_number.join(",") }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
      <template v-else>
        <div
            style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center;">
          <img alt="" src="@/assets/image/e1.png"/>
          <div
              style="
                  font-weight: 400;
                  font-style: normal;
                  font-size: 14px;
                  color: rgb(85, 85, 85);
                  margin-top: 10px;
                  line-height: 28px;
                  height: 28px;
                  text-align: center;
                "
          >
            没有异常相似哦~
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "errText",
  props: {
    companyData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      groupSims: [],
      simList: [],
      currentGroupId: 0,
      currentItem: {},
      currentSimList: [],
      hasSim: false,
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const self = this;
      this.groupSims = this.companyData.details;
      this.groupSims = this.$_.filter(this.groupSims, (item) => {
        return item.error_write_sims.length !== 0
      });

      this.simList = [];
      this.$_.each(this.groupSims, (item, idx) => {
        item.groupId = idx;
        this.$_.each(item.error_write_sims, (_item, _idx) => {
          _item.cont_name = item.cont_name;
          _item.name = item.name;
          _item.file = item.file
          _item.mulu = item.mulu
          _item.cont_mulu = item.cont_mulu
          _item.cont_file = item.cont_file
          _item.groupId = idx
          _item.category = item.category
        })
        this.simList = this.simList.concat(item.error_write_sims);

      });
      if (this.simList.length) {
        this.hasSim = true;
      } else {
        this.hasSim = false;
      }

      this.currentGroupId = 0;
      this.currentItem = this.$_.find(this.groupSims, function (item) {
        return item.groupId === self.currentGroupId
      });

      if (this.currentItem) {
        this.changeCatalog(this.currentItem)
      }

    },
    changeCatalog(item) {
      console.log(item);
      this.currentGroupId = item.groupId;

      if (item.error_write_sims.length) {
        this.currentSimList = item.error_write_sims;
      } else {
        this.currentSimList = [];
      }
    }
  },
  computed: {
    showGroupSims() {
      const temp = this.$_.filter(this.groupSims, (item) => {
        return item.error_write_sims.length !== 0
      })
      return temp
    }
  },
  watch: {
    companyData(val) {
      this.init();
    },
  }
}
</script>


<style lang="scss" scoped>
.sim_tip_text {
  font-weight: 700;
  font-style: normal;
  font-size: 12px;
  color: #333;
}

.table {
  width: 800px;
  margin-left: 16px;
  margin-top: 10px;
}

.red {
  color: #d9001b;
}

.green {
  color: #13b002;
}

.catalogue_item {
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
  font-size: 13px;
  position: relative;
}

.catalogue_title {
  height: 30px;
  line-height: 30px;
  text-align: center;
  // margin-top: 5px;
  font-size: 13px;
  position: relative;
  background-color: #f6f6f6;
  flex: 1;

}

.active_catalogue_item {
  background-color: #d6deee;
  font-weight: 700;
  font-style: normal;
  font-size: 13px;
  color: #000;
  position: relative;

  &::after {
    content: "";

    display: block;
    width: 5px;
    height: 30px;
    background-color: #d6deee;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.pdfTitle {
  height: 43px;
  border-bottom: 1px solid rgba(163, 188, 208, 1);
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  line-height: 43px;
  text-align: center;
}

.simModel {
  border-radius: 5px;
}

.sim_active {
  border: 2px solid #ff5d3f;
}

.simModel_tag {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  //background: rgba(217, 0, 27, 0.2);
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
  cursor: pointer;

}

.simModel_tag_active1 {
  background: #d9001b !important;

}

.simModel_tag_active2 {
  background: #c8c823 !important;

}

.sim_active1 {
  border: 2px solid #d9001b;
}

.sim_active2 {
  border: 2px solid #c8c823;
}
</style>
